/** @format */

import React from "react";
import { Link } from "react-scroll";
import { FiMenu, FiX } from "react-icons/fi";

export default function MobileHeader({ menuOpen, toggleMenu }) {
  return (
    <div
      className={`md:hidden relative z-50 text-black p-4 flex justify-center w-full `}
    >
      <div className="md:hidden">
        <button onClick={toggleMenu} className="focus:outline-none">
          {menuOpen ? (
            <FiX className="w-6 h-6 text-black" />
          ) : (
            <FiMenu className="w-6 h-6 text-black" />
          )}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white text-black p-6 rounded-lg shadow-md absolute top-16 left-4 right-4 z-40">
          <Link
            to="home"
            smooth={true}
            duration={500}
            className="block py-2 cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
            onClick={toggleMenu}
          >
            Home
          </Link>
          <Link
            to="presentation"
            smooth={true}
            duration={500}
            className="block py-2 cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
            onClick={toggleMenu}
          >
            Présentation
          </Link>
          <Link
            to="galeries"
            smooth={true}
            duration={500}
            className="block py-2 cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
            onClick={toggleMenu}
          >
            Galeries
          </Link>

          <Link
            to="telechargements"
            smooth={true}
            duration={500}
            className="block py-2 cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
            onClick={toggleMenu}
          >
            Téléchargements
          </Link>
          <Link
            to="contact"
            smooth={true}
            duration={500}
            className="block py-2 cursor-pointer hover:text-green-800 transition duration-150 ease-in-out"
            onClick={toggleMenu}
          >
            Contact
          </Link>
        </div>
      )}
    </div>
  );
}
